import { Form } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import type { Warranty, WarrantyInput } from '@econtractor/types';
import { ProductsSelect } from 'modules/product';
import { ObjectSelected } from 'modules/objects';
import useWarrantyObjectOptions from '../model/useWarrantyObjectOptions';

interface TabGeneralProps {
    row: Warranty | null;
    disabled: boolean;
}

const TabGeneral = ({ row, disabled }: TabGeneralProps) => {
    const { t } = useTranslation('Warranties');
    const { values, setFieldValue, handleChange } = useFormikContext<WarrantyInput>();
    const objectSelect = useWarrantyObjectOptions(values.productId, values.objectId, row);
    return (
        <fieldset disabled={disabled}>
            <ProductsSelect
                title={t('fields.name')}
                value={values.productId || null}
                required
                disabled={disabled || Boolean(row?.ID)}
                onChange={(product) => {
                    setFieldValue('productId', Number(product?.value) || 0);
                }}
            />
            <Form.Group className="mb-3">
                <Form.Label className="text-muted">{t('fields.serialNumber')}</Form.Label>
                <Form.Control
                    name="serialNumber"
                    required
                    maxLength={255}
                    value={values.serialNumber}
                    onChange={handleChange}
                    disabled={disabled || Boolean(row?.everAssigned)}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label className="text-muted">{t('fields.purchasedAt')}</Form.Label>
                <Form.Control
                    type="date"
                    name="purchasedAt"
                    required
                    value={values.purchasedAt}
                    onChange={handleChange}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label className="text-muted">{t('fields.warrantyUntil')}</Form.Label>
                <Form.Control
                    type="date"
                    name="warrantyUntil"
                    required
                    min={values.purchasedAt}
                    value={values.warrantyUntil}
                    onChange={handleChange}
                />
            </Form.Group>
            <ObjectSelected
                title={t('fields.object')}
                value={objectSelect.value}
                getList={objectSelect.getList}
                disabled={disabled || row?.canAssign === false}
                clearable
                onChange={(object) => setFieldValue('objectId', object?.ID || null)}
            />
        </fieldset>
    );
};

export default TabGeneral;
